import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangePassportNumberForm from './ChangePassportNumberForm'

const ChangePassportNumberButton = ({ writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={writeOffActItem.passportNumber}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
            positionIco='left'
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування номера паспорта'}
            disableClickOutside={true}
            content={
                <ChangePassportNumberForm
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangePassportNumberButton